"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreakType = exports.assetPicture = exports.ASSET_PICTURE_PREFIX = exports.creaturePicture = exports.CREATURE_PICTURE_PREFIX = void 0;
var profile_1 = require("./profile");
Object.defineProperty(exports, "CREATURE_PICTURE_PREFIX", { enumerable: true, get: function () { return profile_1.CREATURE_PICTURE_PREFIX; } });
Object.defineProperty(exports, "creaturePicture", { enumerable: true, get: function () { return profile_1.creaturePicture; } });
Object.defineProperty(exports, "ASSET_PICTURE_PREFIX", { enumerable: true, get: function () { return profile_1.ASSET_PICTURE_PREFIX; } });
Object.defineProperty(exports, "assetPicture", { enumerable: true, get: function () { return profile_1.assetPicture; } });
var streak_1 = require("./streak");
Object.defineProperty(exports, "StreakType", { enumerable: true, get: function () { return streak_1.StreakType; } });
